import {
  CreateIntegrationRequestData,
  Integration,
  IntegrationFormData,
  UpdateIntegrationRequestData,
} from '../types';

export function buildIntegrationFormData(data?: Integration): IntegrationFormData {
  return {
    id: data?.id,
    name: data?.name || '',
    eventType: data?.event_type || 'new_inbox_message',
    url: data?.url || '',
  };
}

export function buildIntegrationRequestData(
  data: IntegrationFormData,
): CreateIntegrationRequestData | UpdateIntegrationRequestData {
  return {
    name: data.name,
    eventType: data.eventType,
    url: data.url,
  };
}
